/** Liste + lecture avoirs — même moteur. Création seulement depuis une facture. */
import { QuotesPage, type QuoteSeed } from "./QuotesPage";

export type CreditSeed = QuoteSeed;

type CreditsPageProps = {
  companyId: number;
  seed?: CreditSeed | null;
  onSeedUsed?: () => void;
  onOpenClient?: (clientId: number) => void;
  onOpenInvoice?: (id: number) => void;
  onOpenQuote?: (id: number) => void;
};

export function CreditsPage(props: CreditsPageProps) {
  return <QuotesPage kind="credit_note" {...props} />;
}
